import React, { useState, useEffect } from "react";
import Button from "./Button";
import "./Popup.scss";

const Popup = ({
  isVisible,
  isSaveDisabled=false,
  headerText,
  saveButtonText,
  handleClose,
  handleSave,
  popupContent,
}) => {
  return (
    isVisible && (
      <div className="popup-container">
        <div className="general-popup">
          <div className="popup-header">
            <h3>{headerText}</h3>
          </div>
          <div className="general-popup-content">{popupContent}</div>
          <div className="popup-footer">
            <Button
              label="Close"
              type="popup-cancel-button"
              onClick={handleClose}
            />
            <Button
              label={saveButtonText || "Save"}
              type="popup-save-button"
              className="add-button"
              onClick={handleSave}
              disabled={!isSaveDisabled}
            />
          </div>
        </div>
      </div>
    )
  );
};

export default Popup;
